import { useQuery } from 'react-query';

import { Comment, CommentableType, getComments, getCommentsKey } from '@utils/backend-api/comments';

export default function useComments(commentableId: number, commentableType: CommentableType) {
  const { data, isLoading: areCommentsLoading } = useQuery<{ comments: Comment[] }>(
    getCommentsKey(commentableId, commentableType),
    // TODO: Adapt for other commentable types
    // TODO: Add pagination. Loading all comments for now just like article pages
    () => getComments({ forum_post_id: commentableId, per_page: 99999, replies_per_comment: 50 })
  );

  return { comments: data?.comments, areCommentsLoading };
}
